module.exports = __webpack_public_path__ + "img/icn_school.749c70c2.svg";